export const CHECKOUT_URL = 'https://soldadura-al.impultienda.ar/checkout/'

export const PRODUCT_IMAGE =
  'https://cdn.magicpatterns.com/uploads/ptAEY5TEKY8ycCh5JJHe86/SOLDADURA-AL.png'

export const AUTHOR_IMAGE =
  'https://cdn.magicpatterns.com/patterns/generated-images/c9e1cb2b-8d3d-486a-92af-aa12b6a3c69c.jpg'

export const WORKSHOP_IMAGE =
  'https://cdn.magicpatterns.com/patterns/generated-images/70e5f66f-cf4d-48a0-a8e3-a5f5c2f5da3f.jpg'

export const stats = [
  { value: '+300', label: 'Praktische Lösungen' },
  { value: '+1.200', label: 'Schweißer' },
  { value: '6', label: 'Meister-Handbücher' },
  { value: '99 %', label: 'Empfehlen es' },
]

export const painPoints = [
  'Verschwendest du Material durch falsche Einstellungen.',
  'Du rätst bei der Stromstärke, jedes Mal wenn sich die Materialstärke ändert.',
  'Deine Schweißnähte sehen bei jeder Übung anders aus.',
  'Du weißt nicht, ob die Schweißnaht der Belastung wirklich standhält.',
  'Jedes Projekt beginnt mit Zweifeln und Improvisation.',
]

export const gainPoints = [
  'Weißt du genau, welche Einstellung du vor dem Start verwenden solltest.',
  'Erzielt du sauberere, stärkere und gleichmäßigere Schweißnähte.',
  'Reduzierst du die Verschwendung von Elektroden und Material.',
  'Kannst du Fehler schneller erkennen und korrigieren.',
  'Schweißt du mit der Sicherheit von jemandem, der weiß, was er tut.',
]

export const forWhom = [
  'Du ein Schweißgerät hast, aber nie wirklich gelernt hast, es richtig zu benutzen.',
  'Du auf YouTube lernst, aber jedes Video etwas anderes sagt.',
  'Du jedes Mal zweifelst, bevor du deine Maschine einstellst.',
  'Du Elektroden und Material durch vermeidbare Fehler verschwendest.',
  'Du deine eigenen Projekte mit Selbstvertrauen herstellen möchtest.',
  'Du für Reparaturen nicht mehr von anderen abhängig sein möchtest.',
  'Du Ergebnisse möchtest, die wirklich professionell aussehen.',
]

export const manuals = [
  {
    number: '1',
    title: 'Null-Fehler-Methode™',
    text: 'Was du vor dem Schweißen tun solltest, um die häufigsten Fehler vom ersten Tag an zu vermeiden.',
  },
  {
    number: '2',
    title: 'Totale Lichtbogenkontrolle™',
    text: 'Beherrsche die Technik, um saubere, gleichmäßige und widerstandsfähige Schweißnähte zu erzielen.',
  },
  {
    number: '3',
    title: 'Meister-Einstellungscode™',
    text: 'Stelle dein Schweißgerät in wenigen Sekunden richtig ein, ohne jemals wieder raten zu müssen.',
  },
  {
    number: '4',
    title: 'Grenzenloses Schweißen™',
    text: 'Lerne, in jeder Position sicher zu schweißen.',
  },
  {
    number: '5',
    title: 'Labor des Schweißers™',
    text: 'Erkenne und korrigiere jeden Schweißfehler mit einer einfachen Sichtprüfung.',
  },
  {
    number: '6',
    title: 'Professionelles Finish™',
    text: 'Erziele Oberflächen und Abschlüsse, die Qualität und Professionalität ausstrahlen.',
  },
]

export const instantAccess = [
  'Die 6 Meister-Handbücher im digitalen Format.',
  'Mehr als 300 praktische Schritt-für-Schritt-Lösungen.',
  'Einstelltabellen, die jederzeit zur schnellen Orientierung bereitstehen.',
  'Visuelle Leitfäden zur Fehlerdiagnose.',
  'Checklisten zum schnellen Nachschlagen.',
  'Zugang über Smartphone, Tablet oder Computer.',
]

export const bonuses = [
  {
    tag: 'Bonus #1',
    title: 'Kostenstelle für Schweißer™',
    text: 'Berechne korrekt, wie viel du für jede Arbeit verlangen solltest.',
    value: '47 €',
    image:
      'https://cdn.magicpatterns.com/uploads/pzQcxwuW9fw7ypXbU2bu5a/BONUS_1_SOLDADURA-AL.png',
  },
  {
    tag: 'Bonus #2',
    title: 'Premium-Finish™',
    text: 'Sorge dafür, dass jedes Projekt aussieht, als käme es direkt aus einer professionellen Werkstatt.',
    value: '37 €',
    image:
      'https://cdn.magicpatterns.com/uploads/59HKsqzs2aUjTevkWjjquU/BONUS_2_SOLDADURA-AL.png',
  },
  {
    tag: 'Bonus #3',
    title: 'Fehler-Diagnose Leitfaden™',
    text: 'Finde das Problem, verstehe die Ursache und korrigiere jeden Schweißfehler.',
    value: '67 €',
    image:
      'https://cdn.magicpatterns.com/uploads/syXw2EyPEZeXjMP1g5S9M1/BONUS_3_SOLDADURA-AL.png',
  },
  {
    tag: 'Bonus #4',
    title: 'Schweißpositionen Meisterleitfaden™',
    text: 'Lerne Schritt für Schritt, in jeder Position sicher und sauber zu schweißen.',
    value: '57 €',
    image:
      'https://cdn.magicpatterns.com/uploads/8KphJCW5CAHycye9Ger1WX/BONUS_4_SOLDADURA-AL.png',
  },
  {
    tag: 'Bonus #5',
    title: 'Labor des Schweißers™',
    text: 'Die professionelle Checkliste für jede Schweißarbeit – kein Schritt wird vergessen.',
    value: '37 €',
    image:
      'https://cdn.magicpatterns.com/uploads/somPRFSsaPc7kNheMQK3kw/BONUS_5_SOLDADURA-AL.png',
  },
]

export const testimonials = [
  {
    name: 'Carlos Medina',
    role: 'Metallbauer · Córdoba, Argentinien',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/aeda4d11-5da7-4ceb-a34a-45a965f1148c.jpg',
    quote:
      'Ich hatte mein Schweißgerät zwei Jahre lang und habe die Stromstärke immer geschätzt. Mit den Tabellen des Meister-Systems kann ich meine Einstellungen in Sekunden überprüfen, und meine Schweißnähte werden gleichmäßiger. Ich verschwende deutlich weniger Elektroden.',
  },
  {
    name: 'Nahuel Ríos',
    role: 'Hobby-Schweißer · Rosario, Argentinien',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/c3dc5b6e-135c-40e2-97d1-8bbd1f3a2c3e.jpg',
    quote:
      'Ich habe über YouTube gelernt, aber jedes Video sagte etwas anderes. Hier ist alles Schritt für Schritt organisiert. Ich habe bereits eigene Projekte umgesetzt und bin bei kleineren Arbeiten viel selbstständiger geworden.',
  },
  {
    name: 'Diego Fernández',
    role: 'Schweißer · Mendoza, Argentinien',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/2060a220-e2bb-4603-a677-48cec4c5eeac.jpg',
    quote:
      'Das Handbuch zur Fehlerdiagnose ist extrem hilfreich. Jetzt kann ich meine Schweißnaht überprüfen und weiß viel schneller, was ich kontrollieren sollte. Mit dem Kosten-Bonus konnte ich außerdem meine Arbeiten besser kalkulieren.',
  },
]

export const faqs = [
  {
    q: 'Wie erhalte ich das Meister-Schweißsystem?',
    a: 'Direkt nach der Zahlung erhältst du eine E-Mail mit deinem digitalen Zugang zu den 6 Meister-Handbüchern und den 5 Exklusiven Boni.',
  },
  {
    q: 'Funktioniert das auch, wenn ich noch nie geschweißt habe?',
    a: 'Ja. Das System wurde so organisiert, dass auch Anfänger die Inhalte Schritt für Schritt verstehen und als praktische Referenz nutzen können.',
  },
  {
    q: 'Ist es auch für mich geeignet, wenn ich bereits Erfahrung habe?',
    a: 'Ja. Auch erfahrenere Schweißer können die Tabellen, Checklisten und Diagnosehilfen als praktische Nachschlagewerke nutzen.',
  },
  {
    q: 'Brauche ich Internet, um es zu nutzen?',
    a: 'Du benötigst Internet, um deinen digitalen Zugang zu erhalten und die Materialien herunterzuladen. Danach kannst du die Dateien auf deinem Gerät speichern.',
  },
  {
    q: 'Ist das eine einmalige Zahlung?',
    a: 'Ja. Du zahlst einmalig und erhältst Zugang zu dem in deinem Angebot angegebenen digitalen System.',
  },
  {
    q: 'Was passiert, wenn es mir nicht gefällt?',
    a: 'Du bist durch die 7-Tage-Zufriedenheitsgarantie geschützt. Wenn du innerhalb dieses Zeitraums feststellst, dass das System nicht deinen Erwartungen entspricht, kannst du uns kontaktieren.',
  },
]

export const recentBuyers = [
  { name: 'Martín G.', country: 'Argentinien' },
  { name: 'Javier R.', country: 'Spanien' },
  { name: 'Luis A.', country: 'Mexiko' },
  { name: 'Andrés P.', country: 'Kolumbien' },
  { name: 'Ricardo S.', country: 'Chile' },
  { name: 'Fernando M.', country: 'Peru' },
  { name: 'Sebastián L.', country: 'Uruguay' },
  { name: 'Camilo D.', country: 'Ecuador' },
  { name: 'Hugo V.', country: 'Paraguay' },
  { name: 'Óscar T.', country: 'Venezuela' },
]
